import {Declension} from "../../declension/declension";
class File {

  constructor(elem) {
    this.file = elem;
    this.name = elem.attr('name');
    if (!window.files) {
      window.files = {};
    }
    window.files[this.name] = [];
	}

  initialize() {
    const component = this;
    let files = this.file;
    let form = files.closest('form');
    let upload = form.find('[data-file-upload]');
    let maxFiles = parseInt(upload.attr('data-file-max'));
    let totalCount = 0
    let typePage = 'review'

    if(window.location.pathname === '/support/feedback/'){
      typePage = 'feedback'
    }

    // добавление фото в список файлов
    files.on('change', (e) => {
      const filesCount = files.get(0).files.length;
      totalCount += filesCount;

      if (totalCount > maxFiles){
        let declension = new Declension()
        alert("Вы можете загрузить максимум "+maxFiles+" "+declension.declension(maxFiles, ['файл', 'файла', 'файлов']));
      } else {
        if (totalCount >= 1) {
          if (upload.find('[data-file-inner]').length < 1) {
            upload.append('<div class="file__inner" data-file-inner></div>');
          }

          for(let i = 0; i < filesCount; i++) {
            const file = files.get(0).files[i];
            window.files[component.name].push(file);
            const reader = new FileReader();
            reader.onload = function(e) {
              component.uploadFile(e.target.result, upload, typePage);
            }
            reader.readAsDataURL(file);
          }
        }
      }
    })

    // удаление фото
    $(document).on('click', '[data-file-remove]', function(e) {
      let el = $(this);
      let item = el.closest('[data-file-item]');
      let inner = el.closest('[data-file-inner]');

      window.files[component.name].splice(item.index(), 1);
      files.val('')
      item.remove();
      let length = inner.find('[data-file-item]').length;
      totalCount = length;

      if (length == 0) {
        inner.remove();
        $('[data-file-button-upload]').removeClass('d-none')
      }

      e.preventDefault();
    });
  }

  uploadFile(src, upload, page) {
    if(page === 'feedback'){
      upload.find('[data-file-inner]').append(`
      <div class="file__item" data-file-item>
        <div class="file__photo">
          <img class="file__img" src="${src}">
        </div>
        <div class="file__content">
          <a href="#" class="link link--monza" data-file-remove>Удалить</a>
        </div>
      </div>
    `)
    }else{
      upload.find('[data-file-inner]').append(`
      <div class="file__item d-flex align-items-center" data-file-item>
        <div class="file__photo">
          <img class="file__img" src="${src}">
        </div>
        <div class="file__content">
          <a href="#" class="link link--monza" data-file-remove>Удалить</a>
        </div>
      </div>
    `)
      $('[data-file-button-upload]').addClass('d-none')
    }
  }
}

export {File};

$(window).on('load', () => {
  let file = [];

  if ($('[data-file]').length > 0) {
    $('[data-file]').each(function(i) {
			file[i] = new File($(this));
			file[i].initialize();
		});
  }
});
